import { RMReWeighingEntity } from "../rm-re-weighing.entity";
import { ReWeighingDto } from "./re-weighment.dto";

export class ReWeighingAdapter{
    public convertDtoToEntity(rmWeighingData: ReWeighingDto):RMReWeighingEntity{
        const entity = new RMReWeighingEntity();
        entity.plantId = rmWeighingData.plantId;
        entity.indentId = rmWeighingData.indentId;
        entity.indentItemId = rmWeighingData.indentItemId;
        entity.grnId = rmWeighingData.grnId;
        entity.grnItemId = rmWeighingData.grnItemId;
        entity.carrierType = rmWeighingData.carrierType;
        entity.expectedCntQty = rmWeighingData.expectedCntQty;
        entity.count = rmWeighingData.count;
        entity.noOfCratesOrNets = rmWeighingData.noOfCratesOrNets;
        entity.quantity = rmWeighingData.quantity;
        if(rmWeighingData.rmReWeighingId){
            entity.rmReWeighingId = rmWeighingData.rmReWeighingId
            entity.updatedUser = rmWeighingData.updatedUser;
        }else{
            entity.createdUser = rmWeighingData.createdUser;

        }
        return entity
    }
}